import { Nullable } from '@/utils/types';
import { ILeaseIngestion, IListFilters } from '@/bundles/LeaseIngestion/types';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export interface ILeaseIngestionListing {
  ids: string[];
  loading: boolean;
  error: Nullable<string>;
}

export interface ILeaseIngestionStore {
  records: Record<string, ILeaseIngestion>;
  listings: Record<string, ILeaseIngestionListing>;
  activeId: Nullable<string>;
  detailLoading: boolean;
  detailError: Nullable<string>;
}

const initialState: ILeaseIngestionStore = {
  records: {},
  listings: {},
  activeId: null,
  detailLoading: false,
  detailError: null,
};

export function buildListingKey (filter: IListFilters): string {
  return JSON.stringify({
    status: filter.status ?? null,
    limit: filter.limit ?? null,
    offset: filter.offset ?? null,
  });
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
